export interface SchoolTheme {
  slug: string;
  primary: string;
  secondary: string;
  accent: string;
  backgroundPattern?: 'constellation' | 'geometry' | 'grid' | 'chain' | 'crystal' | 'neutral';
}

export const schoolThemeMap: Record<string, SchoolTheme> = {
  parashari: {
    slug: 'parashari',
    primary: '#1e3a5f',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'constellation',
  },
  jaimini: {
    slug: 'jaimini',
    primary: '#1e3a5f',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'geometry',
  },
  kp: {
    slug: 'kp',
    primary: '#4b5563',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'grid',
  },
  bnn: {
    slug: 'bnn',
    primary: '#1c1917',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'chain',
  },
  'lal-kitab': {
    slug: 'lal-kitab',
    primary: '#b91c1c',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'geometry',
  },
  numerology: {
    slug: 'numerology',
    primary: '#6b21a8',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'crystal',
  },
  'surya-siddhanta': {
    slug: 'surya-siddhanta',
    primary: '#b45309',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'constellation',
  },
  panchang: {
    slug: 'panchang',
    primary: '#0f766e',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'grid',
  },
  palmistry: {
    slug: 'palmistry',
    primary: '#78350f',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'geometry',
  },
  tantra: {
    slug: 'tantra',
    primary: '#7f1d1d',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'constellation',
  },
  'swara-vigyan': {
    slug: 'swara-vigyan',
    primary: '#0e7490',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'grid',
  },
  vastu: {
    slug: 'vastu',
    primary: '#166534',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'geometry',
  },
  'yantra-vidya': {
    slug: 'yantra-vidya',
    primary: '#7f1d1d',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'geometry',
  },
  ayurveda: {
    slug: 'ayurveda',
    primary: '#15803d',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'neutral',
  },
  yoga: {
    slug: 'yoga',
    primary: '#7c3aed',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'constellation',
  },
  vedanta: {
    slug: 'vedanta',
    primary: '#1e3a5f',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'constellation',
  },
  'bhagavad-gita': {
    slug: 'bhagavad-gita',
    primary: '#b45309',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'chain',
  },
  upanishads: {
    slug: 'upanishads',
    primary: '#4338ca',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'crystal',
  },
  'indian-philosophy': {
    slug: 'indian-philosophy',
    primary: '#374151',
    secondary: '#F4B400',
    accent: '#D89B00',
    backgroundPattern: 'grid',
  },
};

export const defaultSchoolTheme: SchoolTheme = {
  slug: 'default',
  primary: '#F4B400',
  secondary: '#D89B00',
  accent: '#FFD54F',
  backgroundPattern: 'neutral',
};

export function getSchoolTheme(slug: string): SchoolTheme {
  return schoolThemeMap[slug] ?? defaultSchoolTheme;
}

export function applySchoolTheme(theme: SchoolTheme): void {
  const root = document.documentElement;
  root.style.setProperty('--school-primary', theme.primary);
  root.style.setProperty('--school-secondary', theme.secondary);
  root.style.setProperty('--school-accent', theme.accent);
}
